import React from 'react';
import { withTranslation } from 'react-i18next';
import { Form, Input } from 'antd';
import {
    parseBoolOr,
    parseStringOr,
} from '../../App/AppxUtils';

import './index.css';


class InputEmail extends React.Component {
    constructor(props) {
        super(props);

        this.name = parseStringOr(props.name, "email");

        if (this.name === "") {
            throw new Error('Name is required!');
        }

        this.label = parseStringOr(props.label, null);
        this.placeholder = parseStringOr(props.placeholder, null);
        this.disabled = parseBoolOr(props.disabled, false);
        this.required = parseBoolOr(props.required, true);
        this.requiredMessge = parseStringOr(props.requiredMessge, "");
        this.len = parseInt(props.len) || 255;

        if (this.disabled) {
            this.required = false;
        }

        this.setRules();

        this.state = {
            value: "",
        }

        this.onChange = this.onChange.bind(this);
        this.setVal = this.setVal.bind(this);
    }

    setRules() {
        const { t } = this.props;

        if (this.requiredMessge === "") {
            this.requiredMessge = t('Please input your', {field: (this.label != null) ? this.label : this.name});
        }

        this.rules = [
            {
                type: "email",
                message: t('Please enter a valid email!')
            },
            {
                required: this.required,
                message: this.requiredMessge
            }
        ];

        if (Array.isArray(this.props.rules)) {
            for (let i in this.props.rules) {
                let row = this.props.rules[i];

                for (let field in row) {
                    this.rules[i][field] = row[field];
                }
            }
        }
    }

    componentDidUpdate(prevProps) {
        let label = parseStringOr(this.props.label, null);
        let placeholder = parseStringOr(this.props.placeholder, null);
        let requiredMessge = parseStringOr(this.props.requiredMessge, "");

        if (label !== prevProps.label ||
            placeholder !== prevProps.placeholder ||
            requiredMessge !== prevProps.requiredMessge) {
            this.label = label;
            this.placeholder = placeholder;
            this.requiredMessge = requiredMessge;
            this.setRules();
        }
    }

    onChange(e) {
        this.setVal(e.target.value);
    }

    setVal(v) {
        if (undefined !== this.props.onChange) {
            this.props.onChange(this.name, v);
        }

        this.setState({value: v});
    }

    render() {
        return (
            <Form.Item
                name={this.name}
                label={this.label}
                rules={this.rules}
                style={this.props.style}>
                <Input
                    type="email"
                    placeholder={this.placeholder}
                    addonBefore={this.props.addonBefore}
                    addonAfter={this.props.addonAfter}
                    len={this.len}
                    disabled={this.disabled}
                    onChange={this.onChange}
                    onPressEnter={e => e.preventDefault()} />
            </Form.Item>
        )
    }
}

export default withTranslation("appxweb")(InputEmail);
